
export const operationTypeValue = {
    VIEW: 'VIEW', // 查看
    SEND: 'SEND', // 发货
};